import script from "./service-bill-detail.vue?vue&type=script&lang=ts&setup=true"
export * from "./service-bill-detail.vue?vue&type=script&lang=ts&setup=true"

import "./service-bill-detail.vue?vue&type=style&index=0&id=22d4ec67&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22d4ec67"]])

export default __exports__